var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('textarea',{ref:"ueditor",staticClass:"editor",class:{
            editable: !_vm.readonly,
            codemode: _vm.codemode
        },attrs:{"multi-line":"","placeholder":_vm.placeholder,"readonly":_vm.readonly,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }